/* dev/assets/js/o-flat-image.js */
(function ($) {
    "use strict";

    function printRecipe() {
        var width = $(window).width() * 0.9;
        var height = $(window).height() * 0.9;
        var content = `
            <!DOCTYPE html>
            <html>
                <head>
                    <meta charset="utf-8">
                    <title></title>
                    <link rel="stylesheet" href="${localize.themeurl}/assets/css/print.css">
                </head>

                <body class="A4" onload="window.focus(); window.print(); window.close();">
                    <section class="sheet padding-10mm">
                        <article>
                            <div class="logo__wrapper">
                                ${$('.js-print-hero').html()}
                                <img class="logo__image" src="${localize.themeurl}/assets/img/svg/logo_tvp_color_w_text.svg" alt="">
                            </div>
                            
                            <div class="link">
                                <p><strong>${localize.translations.webpage} </strong>${location.href}</p>
                            </div>
                            
                            <div class="row">
                                <div class="left">
                                    <div class="sidebar__wrapper">
                                        <div class="sidebar__headline">
                                            <img class="sidebar__image" src="${localize.themeurl}/assets/img/svg/icons/icon_cooking.svg" alt="">
                                            <div class="sidebar__title">${$('.sidebar__title').html()}</div>
                                        </div>

                                        <div class="sidebar__details">${$('.js-print-left').html()}</div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="right">
                                    ${$('.js-print-right').html()}
                                </div>
                            </div>
                        </article>
                    </section>
                </body>
            </html>`;
        var options = "toolbar=no,location=no,directories=no,menubar=no,scrollbars=yes,top=0,left=0,width=" + width + ",height=" + height;
        var printWindow = window.open('', 'print', options);
        printWindow.document.open();
        printWindow.document.write(content);
        printWindow.document.close();
        printWindow.focus();
    }


    $(function () {
        /* Printing flat image in landscape mode */
        $('.js-print-recipes').click(function () {
            printRecipe();
            return true;
        });

    });

})(jQuery);